import React from 'react';
import { NavLink } from 'react-router-dom';
import { Helmet } from "react-helmet";


const HeadData = (
  <Helmet>
    <title>農業視覺化</title>
    <meta name="description" content="關於農業視覺化，數據資訊來自於政府開放平台，查詢內容包含農作物月平均價格、農作物當日市場批發價格。" />
  </Helmet>
);


export default class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderIndex: 0,
      animation: 'fadeIn',
      imageSet: ['bgImage1', 'bgImage2', 'bgImage3'],
      entryDetails: false
    };

    this.handleEntryDetail = this.handleEntryDetail.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0); //** to load top of the page

    setInterval(() => {
      if (this.state.sliderIndex >= 2) {
        this.setState({
          sliderIndex: 0
        });
      } else {
        this.setState({
          sliderIndex: this.state.sliderIndex + 1
        });
      }
    }, 10000);

    setInterval(() => {
      this.setState({
        animation: this.state.animation === 'fadeIn' ? 'fadeOut' : 'fadeIn'
      });
    }, 5000);
  }

  handleEntryDetail() {
    this.setState({
      entryDetails: !this.state.entryDetails
    });
  }

  render() {
    return (
      <section id="landing-page">
        { HeadData }
        <div id="bg-slider"
          className={ this.state.animation + ' ' +
            this.state.imageSet[this.state.sliderIndex] }>
        </div>
        <header id="title">
          <h1>視覺化農業</h1>
          <h2>讓數據更有效率了解台灣農業</h2>
        </header>

       {/*  TODO
        <div id="entry">
          <NavLink to="/vegitables">蔬菜類</NavLink>
          <NavLink to="/fruits">水果類</NavLink>
          <NavLink to="/grains">雜糧類</NavLink>
          <NavLink to="/special">特作類</NavLink>
          <NavLink to="/flowers">花卉類</NavLink>
        </div> 
       */}

        <div id="entry">
          <div id="dailyEntry">
            <h1><NavLink to="/daily">單日價格查詢</NavLink></h1>
          </div>
          <div id="avgEntry">
            <h1 className={this.state.entryDetails ? "visible" : "invisible"} onClick={() => this.handleEntryDetail()}>月平均歷史查詢</h1>
            <div className={this.state.entryDetails ? "visible" : "invisible"}>
              <NavLink to="/vegitables">蔬菜類</NavLink>
              <NavLink to="/fruits">水果類</NavLink>
              <NavLink to="/grains">雜糧類</NavLink>
              <NavLink to="/special">特作類</NavLink>
              <NavLink to="/flowers">花卉類</NavLink>
            </div>
          </div>
        </div> 
      </section>
    );
  }
};




// WEBPACK FOOTER //
// ./src/components/pages/landing.js